<template>
  <div>
    <Checkin
      :label="'Rifinitura'"
      role="postazione-finitura-gesso"
    />
    <StuckWorkWarningProvider />
  </div>
</template>

<script>
import Checkin from '@/components/plaster/Checkin';
import StuckWorkWarningProvider from '@/components/StuckWorkWarningProvider.vue';

export default {
  name: "Finish",
  components: {
    Checkin,
    StuckWorkWarningProvider,
  },
}
</script>
